import { createAsyncThunk } from '@reduxjs/toolkit';
import { closeModal, openModal } from './VertemGiftSlice';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { vertemGiftApiUrl } from 'Services/Apis/clients';

export const hasAccepted = createAsyncThunk(
    `api/hasAccepted`,
    async (_, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };

        const response = await axios.get(
            `${vertemGiftApiUrl}/termAccept`,
            { headers: customHeaders }
        );
        return response.data;
    }
);

export const signTerm = createAsyncThunk(
    `api/signTerm`,
    async (_, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };
        const response = await axios.post(
            `${vertemGiftApiUrl}/termAccept`,
            {},
            { headers: customHeaders }
        );
        return response.data;
    }
);

export const hasActive = createAsyncThunk(
    `api/hasActive`,
    async (_, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };
        const response = await axios.get(
            `${vertemGiftApiUrl}gifts/GetActiveByCampaign`,
            { headers: customHeaders }
        );
        return response.data;
    }
);

export const getBallonsByParticipant = createAsyncThunk(
    `api/getBallonsByParticipant`,
    async (_, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };

        const response = await axios.get(
            `${vertemGiftApiUrl}/ParticipantBalloon/GetExtractBalloon`,
            { headers: customHeaders }
        );
        return response.data;
    }
);

export const getAvailableBallons = createAsyncThunk(
    `/ParticipantBalloon/GetAvailableBalloon`,
    async (_, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };

        const response = await axios.get(
            `${vertemGiftApiUrl}/ParticipantBalloon/GetAvailableBalloon`,
            { headers: customHeaders }
        );
        return response.data;
    }
);

export const fetchAvailableBallons = createAsyncThunk(
    `api/fetchAvailableBallons`,
    async (_, { dispatch }) => {
        try {
            const response = await dispatch(getAvailableBallons());
            return response.payload;
        } catch (error) {
            throw error;
        }
    }
);

export const fetchAndOpenModal = createAsyncThunk(
    `api/fetchAndOpenModal`,
    async (_, { dispatch }) => {
        try {
            const response = await dispatch(getAvailableBallons());
            const { availableBallons } = useSelector(state => state.VertemGift)
            console.log(availableBallons)
            if (availableBallons.length > 0) {
                dispatch(openModal());
            } else {
                dispatch(closeModal());
            }
            return response.payload;
        } catch (error) {
            throw error;
        }
    }
);


export const getWinners = createAsyncThunk(
    `api/getWinners`,
    async (_, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };
        const response = await axios.get(
            `${vertemGiftApiUrl}ParticipantRedemption/Winners`,
            { headers: customHeaders }
        );
        return response.data;
    }
);

export const getPopBalloon = async (id, user) => {
    const customHeaders = {
        Authorization: `Bearer ${user.access_token}`,
        campaignId: user.profile['custom:campaign_id'],
        catalogId: user.profile['custom:catalog_id'],
        participantId: user.profile['custom:participant_id'],
        username: user.profile.username || user.profile['custom:login'],
        'x-tenant': user.profile['custom:campaign_id'],
        'x-cachekey': user.profile['custom:catalog_id'],
    };

    const response = await axios.post(
        `${vertemGiftApiUrl}ParticipantBalloon/PopBalloon?BalloonId=${id}`,
        {},
        { headers: customHeaders }
    );

    return response.data;
}

export const popBallon = createAsyncThunk(
    `api/popBallon`,
    async (id, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };

        const response = await axios.post(
            `${vertemGiftApiUrl}ParticipantBalloon/PopBalloon?BalloonId=${id}`,
            {},
            { headers: customHeaders }
        );

        return response.data;
    }
);

export const postResgate = createAsyncThunk(
    `api/postResgate`,
    async (id, { getState }) => {
        const { user } = getState().oidc;
        const customHeaders = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'x-tenant': user.profile['custom:campaign_id'],
            'x-cachekey': user.profile['custom:catalog_id'],
        };

        const response = await axios.post(
            `${vertemGiftApiUrl}ParticipantRedemption/Redemption?BalloonRedemptionId=${id}`,
            {},
            { headers: customHeaders }
        );
        return response.data;
    }
);
